module.exports = __webpack_public_path__ + "img/icon-shoppingcenter.b0ef37bf.svg";